import { useCreatePipeline } from '../../../pipelines/hooks/useCreatePipeline';
import { IntroductionWidget } from '../../../shared/components/IntroductionWidget/IntroductionWidget';
import { JobsStrings } from '../../strings';
import { IntroductionWidgetIcon } from '../../../shared/components/IntroductionWidget/IntroductionWidgetIcon';
import { useAnalyticsTracker } from '../../../tracking/hooks/useAnalyticsTracker';
import { JobsTrackers } from '../../jobs-trackers';

export function JobsIntro() {
  const { eventTrack } = useAnalyticsTracker();
  const { createPipeline, creatingPipeline } = useCreatePipeline({ showSuccessToast: false });

  return (
    <IntroductionWidget
      dataId=''
      entity='Jobs'
      title={JobsStrings.introTitle}
      description={JobsStrings.introDescription}
      illustration={<IntroductionWidgetIcon iconName='jobs' dataId='db' />}
      buttonProps={{
        children: creatingPipeline ? 'Creating...' : 'Create Your First Pipeline',
        disabled: creatingPipeline,
        onClick: () => {
          eventTrack({
            action: JobsTrackers.JOB_TRACKER_JOBS_INTRO_CREATE_PIPELINE_CLICK
          });

          createPipeline();
        }
      }}
    />
  );
}
